import type { PublicAppScope } from "@/lib/deployment/public-scope";
import { PUBLIC_APP_SCOPE, isInvoiceOnlyScope } from "@/lib/deployment/public-scope";

export interface AppNavItem {
  to: string;
  label: string;
}

const FULL_APP_TOP_NAV_ITEMS: AppNavItem[] = [
  { to: "/app", label: "Invoices" },
  { to: "/app/invoice-designs", label: "Invoice Designer" },
  { to: "/app/templates", label: "Reusable Presets" },
  { to: "/app/brand-kit", label: "Brand Kit" },
];

const FULL_APP_BOTTOM_NAV_ITEMS: AppNavItem[] = [
  { to: "/app", label: "Invoices" },
  { to: "/app/new", label: "New" },
  { to: "/app/templates", label: "Presets" },
  { to: "/app/brand-kit", label: "Brand Kit" },
];

const INVOICE_ONLY_TOP_NAV_ITEMS: AppNavItem[] = [{ to: "/app", label: "Invoices" }];

const INVOICE_ONLY_BOTTOM_NAV_ITEMS: AppNavItem[] = [
  { to: "/app", label: "Invoices" },
  { to: "/app/new", label: "New" },
  { to: "/app/customers", label: "Customers" },
  { to: "/app/catalog", label: "Items" },
];

export const APP_TOP_NAV_ITEMS: AppNavItem[] = appTopNavItemsForScope();

export const APP_BOTTOM_NAV_ITEMS: AppNavItem[] = appBottomNavItemsForScope();

export const INVOICE_ACTIVE_PATHS = [
  "/app",
  "/app/new",
  "/app/bulk",
  "/app/customers",
  "/app/catalog",
  "/app/settings",
  "/app/invoice",
];

export const INVOICE_DESIGN_ACTIVE_PATHS = ["/app/invoice-designs", "/app/designer"];

export function appTopNavItemsForScope(scope: PublicAppScope = PUBLIC_APP_SCOPE): AppNavItem[] {
  return isInvoiceOnlyScope(scope) ? INVOICE_ONLY_TOP_NAV_ITEMS : FULL_APP_TOP_NAV_ITEMS;
}

export function appBottomNavItemsForScope(scope: PublicAppScope = PUBLIC_APP_SCOPE): AppNavItem[] {
  return isInvoiceOnlyScope(scope) ? INVOICE_ONLY_BOTTOM_NAV_ITEMS : FULL_APP_BOTTOM_NAV_ITEMS;
}

export function isInvoiceAreaPath(pathname: string): boolean {
  return INVOICE_ACTIVE_PATHS.some((path) => matchesPathSegment(pathname, path));
}

export function isInvoiceDesignAreaPath(pathname: string): boolean {
  return INVOICE_DESIGN_ACTIVE_PATHS.some((path) => matchesPathSegment(pathname, path));
}

function matchesPathSegment(pathname: string, path: string): boolean {
  if (path === "/app") return pathname === path;
  return pathname === path || pathname.startsWith(`${path}/`);
}
